<template>
  <main
    v-if="active"
    id="modal-id"
    class="modal modal-md2 active googleSync"
  >
    <a
      aria-label="Close"
      class="modal-overlay"
      @click.prevent="close()"
    ></a>

    <form
      v-if="loaded"
      class="modal-container"
      @submit.prevent="submit()"
    >
      <div class="modal-header">
        <a
          aria-label="Close"
          class="btn btn-clear float-right"
          @click.prevent="close()"
        >
        </a>

        <div class="modal-title h5">
          Selecione os consultórios que deseja sincronizar com o Google
        </div>
      </div>

      <div class="modal-body">
        <multiselect
          v-model="selectedOffices"
          :multiple="true"
          :options="officeList"
          trackBy="id"
          openDirection="bottom"
          selectLabel=""
          label="name"
          placeholder="Selecione o consultório"
          selectGroupLabel=""
          selectedLabel="✔️"
          deselectLabel="❌"
          deselectGroupLabel=""
        />
      </div>

      <div class="modal-footer d-flex">
        <button
          v-if="integrationId"
          :disabled="sending"
          class="btn btn-green"
          @click.prevent="revokeSync()"
        >
          Revogar sincronização
        </button>

        <google-button
          :sending="sending"
          text="Sincronizar com o google"
        />
      </div>
    </form>
  </main>
</template>

<script>
import multiselect from 'vue-multiselect'
import googleButton from '@/components/form/googleButton'
import { mapGetters } from 'vuex'

export default {
  props: ['active'],
  components: {
    multiselect,
    googleButton
  },
  data () {
    return {
      officeList: [],
      selectedOffices: [],
      integrationId: null,
      loaded: false,
      sending: false
    }
  },
  computed: {
    ...mapGetters({
      doctorOffices: 'getOffices'
    })
  },
  watch: {
    'active' (next, prev) {
      if (next) {
        this.init()
      } else {
        this.loaded = false
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    close () {
      this.localActive = false
      this.$emit('cancel', true)
    },
    init () {
      this.selectedOffices = []
      this.officeList = []
      this.integrationId = null
      for (let office of this.doctorOffices) {
        this.officeList.push({
          name: office.name,
          id: office.id
        })
      }
      this.fn_SHOW_PROGRESS()
      this.$http.get(`/user/${this.$store.getters.getProfile.id}/user_api_integration?filterAnd[uaip.name]=GOOGLE_CALENDAR`, this.$store.getters.getAuthHeader).then(res => {
        if (res.data.data) {
          if (res.data.data.length > 0) {
            for (let obj of res.data.data) {
              if (obj.object_class) {
                this.integrationId = obj.id
                if (obj.object_class.indexOf('DoctorOffice') > -1) {
                  for (let office of this.officeList) {
                    if (obj.object_ids.indexOf(`${office.id}`) > -1) {
                      this.selectedOffices.push({
                        id: office.id,
                        name: office.name
                      })
                    }
                  }
                }
              }
            }
          }
        }
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loaded = true
        this.fn_HIDE_PROGRESS()
      })
    },
    revokeSync () {
      const self = this
      this.$store.dispatch('setModalConfirm', {
        title: 'Aviso',
        body: 'Deseja revogar a sincronização?',
        confirmText: 'Revogar',
        cancelText: 'Fechar',
        size: 'sm',
        active: true,
        beforeClose (v) {
          if (v) {
            this.fn_SHOW_PROGRESS()
            self.$http.delete(`/user_api_integration/${self.integrationId}`, self.$store.getters.getAuthHeader).then(res => {
              self.$store.dispatch('setModalConfirm')
              self.$store.dispatch('setModalAlert', {
                title: 'Sucesso',
                body: 'Sincronização com o Google Agenda revogada com sucesso.',
                size: 'sm',
                active: true,
                callback () {
                  self.close()
                }
              })
            }).catch((err) => {
              self.$store.dispatch('setModalConfirm')
              self.$store.dispatch('setModalAlert', {
                title: 'Erro',
                body: 'Erro na revogação. Tente novamente mais tarde ou contate a administração do site.',
                size: 'sm',
                active: true
              })
              console.log(err)
            }).finally(() => {
              self.fn_HIDE_PROGRESS()
            })
          } else {
            self.$store.dispatch('setModalConfirm')
          }
        }
      })
    },
    submit () {
      const objectIds = []

      for (let office of this.selectedOffices) {
        objectIds.push(office.id)
      }

      if (objectIds.length === 0) {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Você precisa escolher ao menos um consultório para realizar a sincronização.',
          size: 'md',
          active: true
        })

        return
      }

      this.sending = true
      let url = `/user/google_calendar/integration_authorize`
      let method = 'post'
      if (this.integrationId) {
        url = `/user_api_integration/${this.integrationId}/object_ids`
        method = 'put'
      }
      const data = {user_api_integration: { objectIds: objectIds }}
      console.log(data)
      this.$http({
        url,
        method,
        data,
        headers: this.$store.getters.getAuthHeader.headers
      }).then(res => {
        if (!this.integrationId) {
          this.$store.dispatch('setNewTab', 'dc_ag-' + this.$store.getters.$_checkAuth)
          this.newTab = window.open(res.data, 'dc_ag-' + this.$store.getters.$_checkAuth)
          this.newTab.focus()
          this.fn_HIDE_PROGRESS()
        } else {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Lista de consultórios sincronizada com sucesso.',
            size: 'sm',
            active: true
          })
        }
      }).catch((err) => {
        console.log(err)
        if (err.error.code === 403) {
          this.$store.dispatch('setModalConfirm', {
            title: 'Ops',
            body: 'Você descobriu um recurso Facilities!<br /><br />Com o Dr. Conecta Facilities, você poderá sincronizar todas as suas consultas com sua agenda do Google Calendar.',
            confirmText: 'Trocar o plano',
            cancelText: 'Fechar',
            active: true,
            size: 'md',
            beforeClose: (v, scope) => {
              scope.sending = true
              if (!v) {
                this.$store.dispatch('setModalConfirm')
              } else {
                this.$router.push('/doctor/plans/select')
                this.$store.dispatch('setModalConfirm')
              }
            }
          })
        }
      }).finally(() => {
        this.sending = false
        this.close()
        this.fn_HIDE_PROGRESS()
      })
    }
  }
}

</script>
